import { render, staticRenderFns } from "./seller-details.vue?vue&type=template&id=95d8b06a"
import script from "./seller-details.vue?vue&type=script&lang=js"
export * from "./seller-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports